import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams } from 'react-router-dom';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../locales/languages';

const BASE_URL = 'https://svdpguadalupe.org';

const HreflangTags = () => {
  const { lang } = useParams();
  const location = useLocation();
  const pathWithoutLang = location.pathname.replace(`/${lang}`, '') || '/';

  return (
    <Helmet>
      <html lang={lang} />
      {SUPPORTED_LANGUAGES.map((l) => (
        <link
          key={l}
          rel="alternate"
          hreflang={l}
          href={`${BASE_URL}/${l}${pathWithoutLang}`}
        />
      ))}
      <link
        rel="alternate"
        hreflang="x-default"
        href={`${BASE_URL}/${DEFAULT_LANGUAGE}${pathWithoutLang}`}
      />
    </Helmet>
  );
};

export default HreflangTags;
